var SURFACE_COLOUR_VARIANTS = {
  "default": {
    activeBackground: 'colours.interface.main',
    background: 'colours.canvas.tertiary.main',
    hoverBackground: 'colours.canvas.tertiary.strong',
    selectedBackground: 'colours.canvas.tertiary.weak',
    text: 'colours.canvas.tertiary.ink'
  },
  layering: {
    activeBackground: 'colours.interface.main',
    background: 'colours.layering.1.main',
    hoverBackground: 'colours.layering.1.strong',
    selectedBackground: 'colours.layering.1.weak',
    text: 'colours.layering.1.ink'
  },
  secondary: {
    activeBackground: 'colours.interface.main',
    background: 'colours.canvas.secondary.main',
    hoverBackground: 'colours.canvas.secondary.strong',
    selectedBackground: 'colours.canvas.secondary.weak',
    text: 'colours.canvas.secondary.ink'
  },
  subnavigation: {
    activeBackground: 'colours.interface.main',
    background: 'colours.navigation.secondary.main',
    hoverBackground: 'colours.navigation.secondary.strong',
    selectedBackground: 'colours.navigation.secondary.weak',
    text: 'colours.navigation.secondary.ink'
  }
};
var SURFACE_VARIANT_KEYS = Object.keys(SURFACE_COLOUR_VARIANTS);

export { SURFACE_COLOUR_VARIANTS, SURFACE_VARIANT_KEYS };
//# sourceMappingURL=variants.js.map
